exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img{width:150px;border-radius:50%;margin:35px 0}img.icon{width:30px}.first-table{border-bottom:1px solid #dee2e61a}.channels-name{text-align:left;font-size:16px;font-weight:400}.channels-code{text-align:right;font-size:16px;font-weight:900}table tr{border-bottom:1px solid #dee2e61a;color:#a2abbd;border-top:unset;cursor:pointer}table tr:last-of-type{border-bottom:unset}table tr td{padding-top:10px;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d31855a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CurrentChannel.vue
// module id = 27
// module chunks = 0